module.exports = __webpack_public_path__ + "assets/GoldAlpha.fc0a8db8b5136aa03f3d684d0ed9b1d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldAlpha.png
// module id = 756
// module chunks = 0